// Kept out of index.js so other pages can link to a template without importing
// the Templates component. The route param is read as a search term, so any
// resource id can be handed straight to it.
export function templatePath(name) {
  const trimmed = (name || "").trim();
  return trimmed ? `/templates/${encodeURIComponent(trimmed)}` : "/templates";
}
